import http from '@/http'

const PATH = (id) => `/customers/${id}/subaccounts`

export default {
    async listSubaccounts({customerId, params}) {
        try {
            const response = await http.get(`${PATH(customerId)}`, { params })
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
     async showSubaccount ({customerId, subaccountId}) {
        try {
            const response = await http.get(`${PATH(customerId)}/${subaccountId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async inviteUser ({customerId, subaccount}) {
        try {
            const response = await http.post(`${PATH(customerId)}/${subaccount.id}/sso/invite-user`, { email_addresses: [subaccount.email_address ]})

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async inviteLegacy ({customerId, subaccount}) {
        try {
            const response = await http.post(`${PATH(customerId)}/${subaccount.id}/sso/invite-legacy`, { email_addresses: [subaccount.email_address] })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async sendInvite ({customerId, subaccount}) {
        try {
            const response = await http.post(`${PATH(customerId)}/${subaccount.id}/sso/send-invite`, { email_address: subaccount.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async revokeInvite ({customerId, subaccount}) {
        try {
            const response = await http.put(`${PATH(customerId)}/${subaccount.id}/sso/revoke-invite`, { email_address: subaccount.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async deactivateUser ({customerId, subaccount}) {
        try {
            const response = await http.put(`${PATH(customerId)}/${subaccount.id}/sso/deactivate-user`, { email_address: subaccount.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async deleteUser ({customerId, subaccount}) {
        try {
            const response = await http.post(`${PATH(customerId)}/${subaccount.id}/sso/delete-user`, { email_address: subaccount.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async forcePasswordChange ({customerId, subaccount}) {
        try {
            const response = await http.put(`${PATH(customerId)}/${subaccount.id}/sso/force-reset-password`, { email_address: subaccount.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async sendPasswordReset ({customerId, subaccount}) {
        try {
            const response = await http.post(`${PATH(customerId)}/${subaccount.id}/sso/reset-password`, { email_address: subaccount.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async remove2Fa ({customerId, subaccount}) {
        try {
            const response = await http.delete(`${PATH(customerId)}/${subaccount.id}/sso/remove-2fa`, { email_address: subaccount.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
}
